import { getOrderItemsTotalSavings } from '../items/get-order-items-total-savings';
// TODO: Add savings from other purchases? e.g. tickets, subscriptions. #286514
export const getOrderTotalSavings = () => getOrderItemsTotalSavings();
